// homemale-homefemale_vs_awaymale-awayfemale
export const lineupTemplates = {
  "4-4_vs_4-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
  ],

  "4-4_vs_4-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
  ],

  "4-4_vs_5-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
  ],

  "4-4_vs_5-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
  ],

  "4-5_vs_4-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
  ],

  "4-5_vs_4-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
  ],

  "4-5_vs_5-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
  ],

  "4-5_vs_5-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer5",
    },
  ],

  "5-4_vs_4-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
  ],

  "5-4_vs_4-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
  ],

  "5-4_vs_5-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
  ],

  "5-4_vs_5-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
  ],

  "5-5_vs_4-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
  ],

  "5-5_vs_4-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
  ],

  "5-5_vs_5-4": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
  ],

  "5-5_vs_5-5": [
    {
      gameNumber: 0,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 1,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 2,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 3,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 4,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer3",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer3",
    },
    {
      gameNumber: 5,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 6,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 7,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer3",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 8,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 9,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 10,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 11,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 12,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 13,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayFemalePlayer4",
    },
    {
      gameNumber: 14,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 15,
      homePlayerId1: "homeMalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 16,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 17,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 18,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 19,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer5",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 20,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 21,
      homePlayerId1: "homeFemalePlayer4",
      homePlayerId2: "homeFemalePlayer5",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 22,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer3",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 23,
      homePlayerId1: "homeMalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayMalePlayer2",
      awayPlayerId2: "awayMalePlayer5",
    },
    {
      gameNumber: 24,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeMalePlayer1",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayMalePlayer1",
    },
    {
      gameNumber: 25,
      homePlayerId1: "homeFemalePlayer2",
      homePlayerId2: "homeMalePlayer4",
      awayPlayerId1: "awayFemalePlayer3",
      awayPlayerId2: "awayMalePlayer3",
    },
    {
      gameNumber: 26,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayFemalePlayer2",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 27,
      homePlayerId1: "homeFemalePlayer5",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayMalePlayer4",
    },
    {
      gameNumber: 28,
      homePlayerId1: "homeFemalePlayer1",
      homePlayerId2: "homeFemalePlayer2",
      awayPlayerId1: "awayFemalePlayer1",
      awayPlayerId2: "awayFemalePlayer2",
    },
    {
      gameNumber: 29,
      homePlayerId1: "homeFemalePlayer3",
      homePlayerId2: "homeFemalePlayer4",
      awayPlayerId1: "awayFemalePlayer4",
      awayPlayerId2: "awayFemalePlayer5",
    },
    {
      gameNumber: 30,
      homePlayerId1: "homeMalePlayer1",
      homePlayerId2: "homeMalePlayer2",
      awayPlayerId1: "awayMalePlayer1",
      awayPlayerId2: "awayMalePlayer2",
    },
    {
      gameNumber: 31,
      homePlayerId1: "homeMalePlayer3",
      homePlayerId2: "homeMalePlayer5",
      awayPlayerId1: "awayMalePlayer4",
      awayPlayerId2: "awayMalePlayer5",
    },
  ],
};